"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.justifyContent = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.justifyContent = type_guard_1.enums([
    'center',
    'start',
    'end',
    'flex-start',
    'flex-end',
    'left',
    'right',
    'normal',
    'space-between',
    'space-around',
    'space-evenly',
    'stretch'
]);
